var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "bg-white q-pa-md full-height" },
    [
      _c("h3", { staticClass: "q-subheading q-ma-none" }, [
        _vm._v(_vm._s(_vm.$t("expense_data_heading")))
      ]),
      _c("supplier-select", {
        attrs: { value: _vm.local.supplier, disable: _vm.isCommitted },
        on: {
          input: function(val) {
            return _vm.update("supplier", val)
          }
        }
      }),
      _c(
        "div",
        { staticClass: "row gutter-sm" },
        [
          _c(
            "q-field",
            {
              staticClass: "col",
              attrs: {
                error: _vm.errors.has("invoiceDate"),
                "error-label": _vm.errors.first("invoiceDate")
              }
            },
            [
              _c("q-datetime", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate.disable",
                    value: "required",
                    expression: "'required'",
                    modifiers: { disable: true }
                  }
                ],
                attrs: {
                  name: "invoiceDate",
                  value: _vm.local.invoiceDate,
                  type: "date",
                  "float-label": _vm.$t("invoice_date"),
                  "data-vv-as": _vm.$t("invoice_date"),
                  format: _vm.$t("date_format"),
                  clearable: "",
                  disable: _vm.isCommitted
                },
                on: {
                  input: function(val) {
                    return _vm.update("invoiceDate", val)
                  }
                }
              })
            ],
            1
          ),
          _c(
            "q-field",
            {
              staticClass: "col",
              attrs: {
                error: _vm.errors.has("deliveryDate"),
                "error-label": _vm.errors.first("deliveryDate")
              }
            },
            [
              _c("q-datetime", {
                attrs: {
                  name: "deliveryDate",
                  value: _vm.local.deliveryDate,
                  type: "date",
                  "float-label": _vm.$t("expense_delivery_date"),
                  "data-vv-as": _vm.$t("expense_delivery_date"),
                  format: _vm.$t("date_format"),
                  clearable: "",
                  disable: _vm.isCommitted
                },
                on: {
                  input: function(val) {
                    return _vm.update("deliveryDate", val)
                  }
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "q-field",
        {
          staticClass: "col",
          attrs: {
            error: _vm.errors.has("accountingPeriod"),
            "error-label": _vm.errors.first("accountingPeriod")
          }
        },
        [
          _c("q-datetime", {
            directives: [
              {
                name: "validate",
                rawName: "v-validate.disable",
                value: "required",
                expression: "'required'",
                modifiers: { disable: true }
              }
            ],
            attrs: {
              name: "accountingPeriod",
              value: _vm.local.accountingPeriod,
              type: "date",
              "float-label": _vm.$t("accounting_period"),
              "data-vv-as": _vm.$t("accounting_period"),
              format: "MMMM",
              clearable: "",
              disable: _vm.isCommitted
            },
            on: {
              input: function(val) {
                return _vm.update("accountingPeriod", val)
              }
            }
          })
        ],
        1
      ),
      _c(
        "q-field",
        {
          attrs: {
            error: _vm.errors.has("invoiceNumber"),
            "error-label": _vm.errors.first("invoiceNumber")
          }
        },
        [
          _c("q-input", {
            directives: [
              {
                name: "validate",
                rawName: "v-validate.disable",
                value: "required",
                expression: "'required'",
                modifiers: { disable: true }
              }
            ],
            attrs: {
              name: "invoiceNumber",
              value: _vm.local.invoiceNumber,
              "float-label": _vm.$t("invoice_number"),
              "data-vv-as": _vm.$t("invoice_number"),
              disable: _vm.isCommitted
            },
            on: {
              input: function(val) {
                return _vm.update("invoiceNumber", val)
              }
            }
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "row" },
        [
          _c(
            "q-field",
            {
              staticClass: "col-8",
              attrs: {
                error: _vm.errors.has("totalNet"),
                "error-label": _vm.errors.first("totalNet")
              }
            },
            [
              _c("money-input", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate.disable",
                    value: "required|numeric",
                    expression: "'required|numeric'",
                    modifiers: { disable: true }
                  }
                ],
                attrs: {
                  name: "totalNet",
                  type: "number",
                  value: _vm.local.totalNet,
                  "float-label": _vm.$t("sum_net"),
                  "data-vv-as": _vm.$t("sum_net"),
                  disable: _vm.isCommitted
                },
                on: {
                  input: function(val) {
                    return _vm.update("totalNet", val)
                  }
                }
              })
            ],
            1
          ),
          _c("currency-input", {
            staticClass: "col-4",
            attrs: {
              value: _vm.local.currency,
              label: _vm.$t("currency"),
              "floating-label": "",
              disable: ""
            }
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "row items-center" },
        [
          _c("q-icon", { attrs: { name: "info", color: "faded" } }),
          _c("span", { staticClass: "q-ml-sm q-body-1 text-faded" }, [
            _vm._v(_vm._s(_vm.$t("expense_convert_currency")))
          ])
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "row" },
        [
          _c(
            "q-field",
            {
              staticClass: "col-8",
              attrs: {
                error: _vm.errors.has("salesTaxAmount"),
                "error-label": _vm.errors.first("salesTaxAmount")
              }
            },
            [
              _c("money-input", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate.disable",
                    value: "required|numeric",
                    expression: "'required|numeric'",
                    modifiers: { disable: true }
                  }
                ],
                attrs: {
                  name: "salesTaxAmount",
                  type: "number",
                  value: _vm.local.salesTaxAmount,
                  "float-label": _vm.$t("sales_tax_amount"),
                  "data-vv-as": _vm.$t("sales_tax_amount"),
                  disable: _vm.isCommitted
                },
                on: {
                  input: function(val) {
                    return _vm.update("salesTaxAmount", val)
                  }
                }
              })
            ],
            1
          ),
          _c(
            "q-field",
            {
              staticClass: "col-4",
              attrs: {
                error: _vm.errors.has("salesTaxRate"),
                "error-label": _vm.errors.first("salesTaxRate")
              }
            },
            [
              _c("sales-tax-input", {
                attrs: {
                  value: _vm.local.salesTaxRate,
                  "float-label": _vm.$t("sales_tax_rate"),
                  "use-default": "",
                  required: "",
                  disable: _vm.isCommitted
                },
                on: {
                  input: function(val) {
                    return _vm.update("salesTaxRate", val)
                  }
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c("h3", { staticClass: "q-subheading q-mb-none" }, [
        _vm._v(_vm._s(_vm.$t("payment_terms_heading")))
      ]),
      _c(
        "div",
        { staticClass: "row gutter-sm" },
        [
          _c(
            "q-field",
            {
              staticClass: "col-4",
              attrs: {
                error: _vm.errors.has("cashDiscount"),
                "error-label": _vm.errors.first("cashDiscount")
              }
            },
            [
              _c("q-input", {
                attrs: {
                  name: "cashDiscount",
                  type: "number",
                  suffix: "%",
                  value: _vm.local.cashDiscount,
                  "float-label": _vm.$t("cash_discount"),
                  "data-vv-as": _vm.$t("cash_discount"),
                  disable: _vm.isCommitted
                },
                on: {
                  input: function(val) {
                    return _vm.update("cashDiscount", val)
                  }
                }
              })
            ],
            1
          ),
          _c(
            "q-field",
            {
              staticClass: "col-8",
              attrs: {
                error: _vm.errors.has("cashDiscountLimit"),
                "error-label": _vm.errors.first("cashDiscountLimit")
              }
            },
            [
              _c("q-datetime", {
                attrs: {
                  name: "cashDiscountLimit",
                  value: _vm.local.cashDiscountLimit,
                  type: "date",
                  "float-label": _vm.$t("cash_discount_payment_until"),
                  "data-vv-as": _vm.$t("cash_discount_payment_until"),
                  format: _vm.$t("date_format"),
                  clearable: "",
                  disable: _vm.isCommitted
                },
                on: {
                  input: function(val) {
                    return _vm.update("cashDiscountLimit", val)
                  }
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "q-field",
        {
          attrs: {
            error: _vm.errors.has("dueDate"),
            "error-label": _vm.errors.first("dueDate")
          }
        },
        [
          _c("q-datetime", {
            attrs: {
              name: "dueDate",
              value: _vm.local.dueDate,
              type: "date",
              "float-label": _vm.$t("due_to_without_cash_discount"),
              "data-vv-as": _vm.$t("due_to_without_cash_discount"),
              format: _vm.$t("date_format"),
              disable: _vm.isCommitted
            },
            on: {
              input: function(val) {
                return _vm.update("dueDate", val)
              }
            }
          })
        ],
        1
      ),
      _c(
        "q-field",
        {
          attrs: {
            error: _vm.errors.has("paidAt"),
            "error-label": _vm.errors.first("paidAt")
          }
        },
        [
          _c("q-datetime", {
            attrs: {
              name: "paidAt",
              value: _vm.local.paidAt,
              type: "date",
              "float-label": _vm.$t("expense_paid_at"),
              "data-vv-as": _vm.$t("expense_paid_at"),
              format: _vm.$t("date_format")
            },
            on: {
              input: function(val) {
                return _vm.update("paidAt", val)
              }
            }
          })
        ],
        1
      ),
      _c("h3", { staticClass: "q-subheading q-mb-none" }, [
        _vm._v(_vm._s(_vm.$tc("project", 1)))
      ]),
      _c("project-select", {
        attrs: {
          value: _vm.local.projectId,
          "float-label": _vm.$tc("project", 1),
          "data-vv-as": _vm.$tc("project", 1),
          clearable: ""
        },
        on: {
          input: function(val) {
            return _vm.update("projectId", val)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }